import { render, staticRenderFns } from "./AddBatchPuiForm.vue?vue&type=template&id=2e1424cb&"
import script from "./AddBatchPuiForm.vue?vue&type=script&lang=js&"
export * from "./AddBatchPuiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports